export default __webpack_public_path__ + "static/media/KOD0159-min.a4a685e0.webp";